import React from 'react'
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { Portal } from '@mui/base';

export default function Notification({ status, text, snackBarOpenProp, handleClose, autoHideDuration=6000 }) {

  function snackBarHandleClose(event, reason) {
    if(reason == "clickaway") return;
    if (handleClose) handleClose();
  }

  return (
    // with portal the snackbar use the top of entire screen not the top of modal
    <Portal>
      <Snackbar
        open={snackBarOpenProp} 
        autoHideDuration={autoHideDuration} 
        onClose={snackBarHandleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity={status && status !== "OK" ? "error" :  "success"} sx={{ width: '100%' }}>
          {text}
        </Alert>
      </Snackbar>
    </Portal>
  )
}
